import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiLogOut, FiUser, FiChevronDown } = FiIcons;

// GYSO Logo URL
const GYSO_LOGO_URL = 'https://www.dropbox.com/scl/fi/x19wn3gvnkldomxojhcx8/GYSO-Logo.png?rlkey=z0gau2aihct344okihofnoke5&st=5uelkmzi&raw=1';

const Header = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src={GYSO_LOGO_URL}
              alt="GYSO"
              className="h-8 w-auto"
            />
            <div>
              <h1 className="text-xl font-semibold text-slate-900">GYSO Dashboard</h1>
              <p className="text-xs text-slate-500">Build & manage all your apps</p>
            </div>
          </Link>
          
          <div className="relative">
            <button 
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
              className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors"
            >
              <div className="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiUser} className="w-4 h-4 text-slate-600" />
              </div>
              <SafeIcon icon={FiChevronDown} className="w-4 h-4 text-slate-600" />
            </button>
            
            {isUserMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200 py-1">
                <button className="w-full flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                  <SafeIcon icon={FiSettings} className="w-4 h-4 mr-3" />
                  Settings
                </button>
                <hr className="my-1 border-slate-200" />
                <button 
                  onClick={handleLogout}
                  className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                >
                  <SafeIcon icon={FiLogOut} className="w-4 h-4 mr-3" />
                  Log out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;